<template>
    <div 
        class="t-posters"
        :style="componentStyles"
    >
        <div class="t-posters-lists">
            <slot name="lists">
                <OPList />
            </slot>
        </div>
        <div class="t-posters-map-wrapper">
            <div class="t-posters-map">
                <slot name="map">
                    <OPMAP />
                </slot>
            </div>
            <div class="t-posters-icons" v-if="componentParams.is_show_map_service">
                <slot name="icons">
                    <OPMapIcons />
                </slot>
            </div>
        </div>
        <div class="t-posters-info">
            <div class="t-posters-player">
                <slot name="player">
                    <OPPlayer />
                </slot>
            </div>
            <div class="t-posters-widget">
                <slot name="widget">
                    <OPQrWidget />
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import OPMAP from '../../organisms/o-p-map/o-p-map';
import OPList from '../../organisms/o-p-list/o-p-list';
import OPPlayer from '../../organisms/o-p-player/o-p-player';
import OPMapIcons from '../../organisms/o-p-map-icons/o-p-map-icons';
import OPQrWidget from '../../organisms/o-p-qr-widget/o-p-qr-widget';

import {SET_ACTIVE_VIEW} from "@/shared/components/map-viewer/constants/map-commands";

export default {
    name: 'TPosters',
    components: {
        OPMAP,
        OPList,
        OPPlayer,
        OPQrWidget,
        OPMapIcons
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.TPosters.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.TPosters.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.TPosters.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.TPosters.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
    },
    mounted() {
        this.$bus.$emit(SET_ACTIVE_VIEW, 'floorView');
    }
}
</script>

<style lang="scss" src="./theme.scss" />